import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAllFAQ, LazyArticleList, LazyBrandsGrid, LazyCatalogPromoBanner, LazyChoiceBox, LazyColoredHeader, LazyCompanyHero, LazyContactDetails, LazyDealersGrid, LazyDescriptionList, LazyEmployeeSlider, LazyHowItWorks, LazyJobList, LazyLegalDocumentation, LazyMainCTA, LazyMainComparison, LazyMainFAQ, LazyMainHero, LazyMainMSP, LazyMainMedia, LazyMainPartner, LazyMainPress, LazyMainReviews, LazyPartnerLogos, LazyTabularData, LazyTryBuyInfo, LazyVehicleCatalog, LazyWhoWeAre, LazyCmsBlogList, LazyCmsBrandList, LazyCmsBreadcrumbs, LazyCmsCatalog, LazyCmsConsultationBanner, LazyCmsCustomFaq, LazyCmsDivider, LazyCmsFeatureIcon, LazyCmsFlexLayout, LazyCmsFooter, LazyCmsGarageList, LazyCmsGridLayout, LazyCmsHeadline, LazyCmsHubspotForm, LazyCmsInfoBox, LazyCmsLink, LazyCmsPicture, LazyCmsReviewCarousel, LazyCmsRichContent, LazyCmsTeamList, LazyCmsVideo, LazyBlogCtaButton, LazyEmbedYoutube, LazyNewsletterInline, LazyCmsButton, LazyCmsDualRange, LazyCmsJobWidget, LazyCmsLangSwitch, LazyCmsLoading, LazyCmsMaterialIcon, LazyCmsPagination, LazyCmsSelect, LazyCmsSeoHealth, LazyCmsSocialIcons, LazyCmsVehicleCard } from '#components'
const lazyGlobalComponents = [
  ["AllFAQ", LazyAllFAQ],
["ArticleList", LazyArticleList],
["BrandsGrid", LazyBrandsGrid],
["CatalogPromoBanner", LazyCatalogPromoBanner],
["ChoiceBox", LazyChoiceBox],
["ColoredHeader", LazyColoredHeader],
["CompanyHero", LazyCompanyHero],
["ContactDetails", LazyContactDetails],
["DealersGrid", LazyDealersGrid],
["DescriptionList", LazyDescriptionList],
["EmployeeSlider", LazyEmployeeSlider],
["HowItWorks", LazyHowItWorks],
["JobList", LazyJobList],
["LegalDocumentation", LazyLegalDocumentation],
["MainCTA", LazyMainCTA],
["MainComparison", LazyMainComparison],
["MainFAQ", LazyMainFAQ],
["MainHero", LazyMainHero],
["MainMSP", LazyMainMSP],
["MainMedia", LazyMainMedia],
["MainPartner", LazyMainPartner],
["MainPress", LazyMainPress],
["MainReviews", LazyMainReviews],
["PartnerLogos", LazyPartnerLogos],
["TabularData", LazyTabularData],
["TryBuyInfo", LazyTryBuyInfo],
["VehicleCatalog", LazyVehicleCatalog],
["WhoWeAre", LazyWhoWeAre],
["CmsBlogList", LazyCmsBlogList],
["CmsBrandList", LazyCmsBrandList],
["CmsBreadcrumbs", LazyCmsBreadcrumbs],
["CmsCatalog", LazyCmsCatalog],
["CmsConsultationBanner", LazyCmsConsultationBanner],
["CmsCustomFaq", LazyCmsCustomFaq],
["CmsDivider", LazyCmsDivider],
["CmsFeatureIcon", LazyCmsFeatureIcon],
["CmsFlexLayout", LazyCmsFlexLayout],
["CmsFooter", LazyCmsFooter],
["CmsGarageList", LazyCmsGarageList],
["CmsGridLayout", LazyCmsGridLayout],
["CmsHeadline", LazyCmsHeadline],
["CmsHubspotForm", LazyCmsHubspotForm],
["CmsInfoBox", LazyCmsInfoBox],
["CmsLink", LazyCmsLink],
["CmsPicture", LazyCmsPicture],
["CmsReviewCarousel", LazyCmsReviewCarousel],
["CmsRichContent", LazyCmsRichContent],
["CmsTeamList", LazyCmsTeamList],
["CmsVideo", LazyCmsVideo],
["BlogCtaButton", LazyBlogCtaButton],
["EmbedYoutube", LazyEmbedYoutube],
["NewsletterInline", LazyNewsletterInline],
["CmsButton", LazyCmsButton],
["CmsDualRange", LazyCmsDualRange],
["CmsJobWidget", LazyCmsJobWidget],
["CmsLangSwitch", LazyCmsLangSwitch],
["CmsLoading", LazyCmsLoading],
["CmsMaterialIcon", LazyCmsMaterialIcon],
["CmsPagination", LazyCmsPagination],
["CmsSelect", LazyCmsSelect],
["CmsSeoHealth", LazyCmsSeoHealth],
["CmsSocialIcons", LazyCmsSocialIcons],
["CmsVehicleCard", LazyCmsVehicleCard],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
